<template>
  <section
    :class="contentClasses"
    data-cy="ds-page-content"
  >
    <slot />
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_PAGE_CONTENT_CLASSES, DS_PAGE_CONTENT_PADDING_CLASSES } from "../constants/classes";
import type { DSPageContentProps } from "../types/props";
import { DS_PAGE_CONTENT_PADDING } from "../types/props";

const props = withDefaults(defineProps<DSPageContentProps>(), {
  padding: DS_PAGE_CONTENT_PADDING.Medium,
});

const contentClasses = computed(() => [DS_PAGE_CONTENT_CLASSES.Root, DS_PAGE_CONTENT_PADDING_CLASSES[props.padding]]);
</script>
